import { Component } from 'react'
import { connect } from "react-redux"
import * as actions from "../../../actions"

import { Container, Button, ButtonContent, TableRow, TableHeaderCell, TableHeader, TableCell, TableBody, Table, Grid, GridColumn, Input, Loader, Pagination, Popup, Icon } from 'semantic-ui-react'

import { saveAs } from "file-saver"
import writeXlsxFile from 'write-excel-file'
import { format } from "date-fns"

var filteredClients = []

class Documents extends Component {
    state = { clients: null, activePage: 0, itemsPerPage: 20, filterFYE: [], filterMonthOfAgreement: [] }

    componentDidMount() {
        this.props.fetchClients()
        this.props.fetchRoles()
    }

    renderTableRows() {
        filteredClients = []
        for (const client of this.props.clients) {
            if (client.clientDocs == null || client.clientDocs.length === 0) continue
            filteredClients.push(client)
        }
        var data = []
        if (this.state.isSearching) {
            for (var x = 0; x < filteredClients.length; x++) {
                let cli = filteredClients[x]
                if (cli.clientInfo.companyName != null) {
                    if (cli.clientInfo.companyName.toLowerCase().includes(this.state.searchString.toLowerCase())) {
                        data.push(cli)
                        continue
                    }
                }
                if (cli.clientInfo.group != null) {
                    if (cli.clientInfo.group.toLowerCase().includes(this.state.searchString.toLowerCase())) {
                        data.push(cli)
                        continue
                    }
                }
            }
        } else {
            data = filteredClients.slice(this.state.activePage*this.state.itemsPerPage, this.state.activePage*this.state.itemsPerPage+this.state.itemsPerPage)
        }
        var rows = []
        for (var i = 0; i < data.length; i++) {
            const client = data[i]
            let a = this.getDocCountOfStatus('Received', client.clientDocs)
            let b = this.getDocCountOfStatus('In Processing', client.clientDocs)
            let c = this.getDocCountOfStatus('Ready to Return', client.clientDocs)
            rows.push(
                <TableRow key={i}>
                    <TableCell>{client.clientInfo.companyName}</TableCell>
                    <TableCell>{client.clientInfo.roc}</TableCell>
                    <TableCell>{a}</TableCell>
                    <TableCell>{b}</TableCell>
                    <TableCell>{c}</TableCell>
                    <TableCell>{a + b + c}</TableCell>
                    <TableCell collapsing>
                        <Button circular basic icon='eye' onClick={this.handleViewClicked.bind(this, client)}/>
                    </TableCell>
                </TableRow>
            )
        }
        return rows
    }

    renderTable() {
        if (this.props.clients == null) {
            return <Loader active size="large">Loading</Loader>
        } else {
            return (
                <Table celled striped compact>
                    <TableHeader>
                        <TableRow>
                            <TableHeaderCell>Company Name</TableHeaderCell>
                            <TableHeaderCell width='2'>ROC</TableHeaderCell>
                            <TableHeaderCell collapsing>Received</TableHeaderCell>
                            <TableHeaderCell collapsing>In Processing</TableHeaderCell>
                            <TableHeaderCell collapsing>Ready to Return</TableHeaderCell>
                            <TableHeaderCell collapsing>Total</TableHeaderCell>
                            <TableHeaderCell></TableHeaderCell>
                        </TableRow>
                    </TableHeader>
                    <TableBody>
                    {this.renderTableRows()}
                    </TableBody>
                </Table>
            )
        }
    }

    renderPagination() {
        if (this.props.clients == null) return
        const pagesRequired = Math.ceil(filteredClients.length / this.state.itemsPerPage)
        return (
            <Pagination defaultActivePage={1} totalPages={pagesRequired} siblingRange={2} onPageChange={this.handlePageChange}/>
        )
    }

    renderDownloadButton() {
        if (!!this.props.user) {
            if (!!this.props.user.role) {
                if (this.props.user.role.name.toLowerCase() === 'superadmin') {
                    return (
                        <Button style={{ width: "80px", marginRight: '10px' }} animated='fade' color='red' floated='right' onClick={this.handleDownloadClicked}>
                            <ButtonContent hidden>Export</ButtonContent>
                            <ButtonContent visible>
                                <Icon name='download' />
                            </ButtonContent>
                        </Button>
                    )
                }
            }
        }
        return 
    }

    render() {
        return (
            <Container>
                <br />
                <Grid>
                <GridColumn floated='left' width={5}><h1>Clients with Documents</h1></GridColumn>
                    <GridColumn width={6}>
                        <Popup trigger={<Input fluid placeholder='Search client...' onChange={this.handleChangeSearchField} />} on='focus' wide='very' position='bottom left' 
                        header='Client Search' content="Search by company name, group."/>
                    </GridColumn>
                    <GridColumn floated='right' width={5}>
                        <Button basic color='black' floated='right' style={{ marginLeft: 10 }} onClick={this.props.onViewLocations} >
                            <Icon name='map marker alternate' />
                            Locations
                        </Button>
                        {this.renderDownloadButton()}
                    </GridColumn>
                </Grid>
                {this.renderTable()}
                {this.renderPagination()}
                <br /><br /><br />
            </Container>
        )
    }

    handleChangeSearchField = e => {
        const { value } = e.target
        if (value.length < 2 && !this.state.isSearching) {
            return
        }
        if (value.length < 2) {
            this.setState({ isSearching: false })
        } else {
            this.setState({ isSearching: true, searchString: value })
        }
    }

    handlePageChange = (e, { activePage}) => {
        let page = activePage-1
        this.setState({ activePage: page })
    }

    handleViewClicked(client) {
        this.props.handleViewDoc(client)
    }

    getDocCountOfStatus(status, records) {
        var count = 0
        for (const record of records) {
            for (const doc of record.docs) {
                if (doc.status === status) {
                    count+=1
                }
            }
        }
        return count
    }

    async handleDownloadClicked() {
        let data = []
        let headerRow = [{ value: 'Client', fontWeight: 'bold' }, { value: 'Document Type', fontWeight: 'bold' }, { value: 'Description', fontWeight: 'bold' }, { value: 'Remarks', fontWeight: 'bold' }, { value: 'Status', fontWeight: 'bold' }, { value: 'Audit Trail', fontWeight: 'bold' }, { value: 'id', fontWeight: 'bold' }]
        data.push(headerRow)
        for (const client of filteredClients) {
            for (const clientDoc of client.clientDocs) {
                for (const doc of clientDoc.docs) {
                    const arr = []
                    arr.push({ value: client.clientInfo.companyName })
                    arr.push({ value: doc.type })
                    arr.push({ value: doc.description })
                    arr.push({ value: doc.remarks })
                    arr.push({ value: doc.status })
                    if (doc.auditTrail) {
                        let auditTrailArr = []
                        for (const trail of doc.auditTrail) {
                            var str = trail.status + " at " + format(trail.date, "d MMMM, yyyy 'at' hh:mm a") + " by " + trail.user + ".\n"
                            if (!!trail.initials) {
                                if (trail.status.includes('Returned')) {
                                    str = trail.status + " at " + format(trail.date, "d MMMM, yyyy 'at' hh:mm a") + " (e-Signature obtained from client by " + trail.initials + ").\n"
                                } else {
                                    str = trail.status + " at " + format(trail.date, "d MMMM, yyyy 'at' hh:mm a") + " (QR code scanned by " + trail.initials + ").\n"
                                }
                            }
                            auditTrailArr.push(str)
                        }
                        arr.push({ value: auditTrailArr.join(' ') })
                    }
                    arr.push({ value: doc.id?.toString() })
                    data.push(arr)
                }
            }
        }
        const blob = await writeXlsxFile([data], {sheets: ['Documents'], stickyRowsCount: 1})
        let formattedDate = format(Date(), "d MMMM yyyy hh-mm a")
        saveAs(blob, `FMD-Documents-Database-${formattedDate}.xlsx`)
    }
}

function mapStateToProps({ clients, roles, user }) {
    return { clients, roles, user }
}

export default connect(mapStateToProps, actions)(Documents)

